import { Component, Input, OnInit } from '@angular/core';
import { Routes } from '@angular/router';
import { PageUsers } from 'src/api/models';
import { UserService } from 'src/api/services';
import { appRoutes } from 'src/app/app-routing.module'; // Adjust the path as needed

// todo: fix styles
// todo: install license

@Component({
  selector: 'app-site-map',
  templateUrl: './site-map.component.html',
  styleUrls: ['./site-map.component.css']
})
export class SiteMapComponent implements OnInit {

  @Input() siteMap: any[];
  pages: PageUsers[];

  constructor(public userSvc: UserService){

  }

  ngOnInit() {
    if (this.siteMap == null){
      this.userSvc.UserWhosActive().subscribe(r =>{
        this.pages = r;
      });
      this.siteMap = this.generateSiteMap(appRoutes);
      console.log(this.siteMap);
    }
  }

  generateSiteMap(routes: Routes, parentPath: string = ''): any[] {
    return routes.map(route => {
      const path = parentPath + '/' + (route.path || '');
      const children = route.children ? this.generateSiteMap(route.children, path) : [];
      return { path, route, children };
    });
  }

}
